const followUpsWithPaymentMutationInFlight = new Set<number>();
type FailureReader = (ids: readonly number[]) => Promise<void>;
const failureReaders = new Set<FailureReader>();

// A rejected response can still have persisted. Mounted list owners read back, never retry the write.
export const subscribeFollowUpPaymentFailure = (reader: FailureReader): (() => void) => {
    failureReaders.add(reader);
    return () => {
        failureReaders.delete(reader);
    };
};

export const runFollowUpPaymentMutation = async (
    followUpIds: readonly number[],
    intent: () => Promise<boolean>,
): Promise<boolean> => {
    const uniqueIds = Array.from(new Set(followUpIds));
    if (
        uniqueIds.length !== followUpIds.length ||
        uniqueIds.some((id) => !Number.isSafeInteger(id) || id <= 0) ||
        uniqueIds.some((id) => followUpsWithPaymentMutationInFlight.has(id))
    ) {
        return false;
    }

    uniqueIds.forEach((id) => followUpsWithPaymentMutationInFlight.add(id));
    let successful = false;
    try {
        successful = await intent();
        return successful;
    } finally {
        try {
            if (!successful) {
                await Promise.all(
                    Array.from(failureReaders, async (reader) => {
                        try {
                            await reader(uniqueIds);
                        } catch (_error) {
                            /* Never strand a lease on reader failure. */
                        }
                    }),
                );
            }
        } finally {
            uniqueIds.forEach((id) => followUpsWithPaymentMutationInFlight.delete(id));
        }
    }
};
